import { useModernComponent } from '~/hooks';
import { IBackWhiteButtonProps } from './Types';
import { BackWhiteButton } from './BackWhiteButton';
import BackWhiteButtonLegacy from './Legacy';

export const BackWhiteButtonProxy = ({
  whiteArrow,
  containerStyle = {},
  backRoute,
}: IBackWhiteButtonProps) => {
  const isUseModern = useModernComponent('commons.BackWhiteButton');

  if (!isUseModern) {
    return (
      <BackWhiteButtonLegacy
        whiteArrow={whiteArrow}
        containerStyle={containerStyle}
        backRoute={backRoute}
      />
    );
  }

  return (
    <BackWhiteButton
      whiteArrow={whiteArrow}
      containerStyle={containerStyle}
      backRoute={backRoute}
    />
  );
};
